
<template>
<div class="form-container">
  <div class="form-region">
	   <com-page-title></com-page-title>
 <el-form :class="$store.state.operate=='详情'?'form-disabled':''" :disabled="$store.state.operate=='详情'"  ref="form" :model="form" label-width="160px">

		 <el-form-item  required label='标题'>
		<el-input placeholder='请填写' v-model='form.title' maxlength='50' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item  required label='副标题'>
		<el-input placeholder='请填写' v-model='form.subTitle' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item>
		 <!-- <el-form-item  label=''>
		<el-input  type='textarea' v-model='form.brief' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item> 
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.types' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.groups' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.status' clearable></el-input>
		 </el-form-item>
		 -->
		 <el-form-item required  label='填充方式'>
		  	<el-radio-group v-model="form.status">
		  		<el-radio  :label="10">用户领取</el-radio>
		  		<el-radio  :label="20">后台发放</el-radio>
				<el-radio  :label="30">新人注册</el-radio>
				<el-radio  :label="40">邀请福利</el-radio>
				<el-radio  :label="50">自动发放</el-radio>
		  	</el-radio-group>
		  	 </el-form-item>
		 <el-form-item required label='金额限制'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.priceLimit' clearable></el-input>
		 </el-form-item>
		 <el-form-item required label='价值'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.couponVal' clearable></el-input>
		 </el-form-item>
	
		 <el-form-item  label='是否上架'>
		<el-switch v-model='form.isShow'></el-switch>
		 </el-form-item>
		 <el-form-item required  label='计时方式'>
		  	<el-radio-group v-model="form.useWay">
		  		<el-radio  :label="10">按日期</el-radio>
		  		<el-radio  :label="20">按时长</el-radio>
		  	</el-radio-group>
		  	 </el-form-item>
			 <el-form-item v-if="form.useWay==20"  label='天数'>
			 <el-input placeholder='请填写' v-int  type='number' v-model='form.upperLimit' clearable></el-input>
			  </el-form-item>
			  <el-form-item v-if="form.useWay==10"  label='开始时间'>
			   <el-date-picker type='datetime' placeholder='请选择' v-model='form.startTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
			    </el-form-item>
			    <el-form-item v-if="form.useWay==10"  label='结束时间'>
			   <el-date-picker type='datetime' placeholder='请选择' v-model='form.endTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
			    </el-form-item>
		<!-- 
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.deductionWay' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.upperLimit' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.percentage' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.useWay' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label=''>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.couponNum' clearable></el-input>
		 </el-form-item>
		 <el-form-item   label=''>
		<el-date-picker type='date' placeholder='请选择' v-model='form.useTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
		 </el-form-item>
		 <el-form-item   label=''>
		<el-date-picker type='date' placeholder='请选择' v-model='form.closeTime' :editable='false'  clearable prefix-icon='none'></el-date-picker>
		 </el-form-item>
		 <el-form-item   label=''>
		<el-input placeholder='请填写' v-model='form.productClass' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item   label=''>
		<el-input placeholder='请填写' v-model='form.productType' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item   label=''>
		<el-input placeholder='请填写' v-model='form.ext' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item   label=''>
		<el-input placeholder='请填写' v-model='form.hashExt' maxlength='2000' show-word-limit clearable></el-input>
		 </el-form-item> -->
   <el-form-item>
     <el-button type="primary" @click="onSubmit">立即提交</el-button>
   </el-form-item>
 </el-form>
 </div>
</div>
</template>
<script>
  export default {
	  props: {
	  	id: {//主键id
	  		type: String,
	  		default: ''
	  	}
	  },
  data() {
  return {
    dateRange:[],//表单限制日期
  form: {
	id:'',//
	title:'',//
	subTitle:'',//
	brief:'',//
	types:'',//
	groups:'',//
	status:'',//
	priceLimit:'',//
	couponVal:'',//
	startTime:'',//
	endTime:'',//
	isShow:true,//
	deductionWay:'',//
	upperLimit:'',//
	percentage:'',//
	useWay:'',//
	couponNum:'',//
	useTime:'',//
	closeTime:'',//
	productClass:'',//
	productType:'',//
	productIds:'',//
	ext:'',//
	hashExt:'',//
	createId:'',//
	createTime:'',//
	timeLimit:false,//
  }
  }
  },
  methods: {
 onSubmit() {//表单提交
	 this.form.id=this.$store.state.operate=='复制'?'':this.id;
	if(this.form.timeLimit&&dateRange.length==0){
	  this.$message.error('请选择限制时间');return ;
		 }
	if(this.dateRange.length==2){
	  this.form.startTime=this.dateRange[0];
	  this.form.endTime=this.dateRange[1];
		 }
if(!this.form.title){
		 this.$message.error('请填写标题');return;
	}
	if(!this.form.subTitle){
		 this.$message.error('请填写副标题');return;
	}
	if(!this.form.status){
		 this.$message.error('请选择填充方式');return;
	}
	if(!this.form.priceLimit){
		 this.$message.error('请填写金额限制');return;
	}
	if(!this.form.couponVal){
		 this.$message.error('请填写价值');return;
	}
	if(!this.form.useWay){
		 this.$message.error('请选择计时方式');return;
	}
	if(this.form.useWay==10&&!this.form.startTime){
	 this.$message.error('请选择开始时间');return;
		 }
		 if(this.form.useWay==10&&!this.form.endTime){
		  this.$message.error('请选择结束时间');return;
		 	 }
			 if(this.form.useWay==20&&!this.form.upperLimit){
			  this.$message.error('请填写天数');return;
			 	 }
	 let url=this.form.id?`/api/Coupon/PostCouponUpdate`:`/api/Coupon/PostCouponAppend`;
	 let data=this.form;
 this.$axios.post(url,data).then(e => {
   this.$emit("callbackPage",{statusText:this.form.id?'编辑':'添加'}); 
  });
 }
  },mounted() {//根据id获取表单数据
	  if(this.id){
		  this.$axios.get(`/api/Coupon/GetCoupon?id=${this.id}`).then(e => {
		   this.form=e;
		      if(this.$store.state.operate=='复制'){
			    this.$message.success('内容已经复制到表单');
		   }
		  });
	  }
      }
  }
</script>
